export const USER_LOADING = "USER/loading";
export const USER_WARNING = "USER/warning";
export const USER_ERROR = "USER/error";
export const USER_LOGIN = "USER/login";
export const USER_REGISTER = "USER/register";

export const USER_GET = "USER/get";
export const USER_UPDATE = "USER/update";
